// extracted by mini-css-extract-plugin
export var orderDetails = "_ml-2";
export var orderImage = "_ml-1";
export var orderMeta = "_ml-3";
export var orderSummary = "_ml-0";
export var rightArrow = "_ml-4";